// extracted by mini-css-extract-plugin
module.exports = {"root":"tooltipContainer_root__1dzPW"};